<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                'bg-gray-600': sharedService.userTheme === 'dark',
                'bg-indigo-50': sharedService.userTheme === 'light'}">
      <div class="flex flex-row items-center">
        <div class="flex flex-row w-full">
          <div>
            <span style="font-weight:bold;">Specialty: </span>
            <span>{{list.length}}</span>
            <br />
            <span style="font-weight:bold;">Total Volume: </span>
            <span>{{labService.totalVolume}}</span>
          </div>
        </div>

        <div class="flex flex-row">
          <button mat-icon-button *ngIf="editMode == 'list' && !labService.readonly" matTooltip="Add New" (click)="addLabSpecialty()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">add</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list' && !labService.readonly" matTooltip="Save" (click)="saveLabSpecialty()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">save</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list'" matTooltip="Cancel" (click)="cancel()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">cancel</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode == 'edit' && !labService.readonly" matTooltip="Delete" (click)="deleteLabSpecialty(0)"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''" class="text-red-500">delete</mat-icon>
          </button>
        </div>
      </div>
    </mat-card>
  </div>

  <div class="flex flex-row" *ngIf="editMode == 'list'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
        'bg-gray-700': sharedService.userTheme === 'dark',
        'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <div class="flex flex-col" *ngIf="list.length > 0">
          <div class="flex flex-row">
            <mat-form-field class="w-1/4">
              <input matInput id="listFilter" (keyup)="filterTable($event)" placeholder="Filter"
                value="{{listFilter}}" />

              <button *ngIf="listFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div style="overflow-x:auto">
            <div class="flex flex-row">
              <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                class="mat-elevation-z8 w-full" matSortActive="majorCat" matSortDirection="asc">
                <ng-container matColumnDef="majorCat">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Specialty</th>
                  <td mat-cell *matCellDef="let spec">{{spec.majorCat}}</td>
                </ng-container>
                <ng-container matColumnDef="t_CD">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>TCD</th>
                  <td mat-cell *matCellDef="let spec">{{spec.t_cd}}</td>
                </ng-container>
                <ng-container matColumnDef="code">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Sub Specialty</th>
                  <td mat-cell *matCellDef="let spec">{{spec.code}}</td>
                </ng-container>
                <ng-container matColumnDef="pt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>PT</th>
                  <td mat-cell *matCellDef="let spec">{{spec.pt}}</td>
                </ng-container>
                <ng-container matColumnDef="volume">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Volume</th>
                  <td mat-cell *matCellDef="let spec">{{spec.volume}}</td>
                </ng-container>
                <ng-container matColumnDef="dateOpened">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Opened</th>
                  <td mat-cell *matCellDef="let spec">{{spec.dateOpened}}</td>
                </ng-container>
                <ng-container matColumnDef="dateClosed">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Closed</th>
                  <td mat-cell *matCellDef="let spec">{{spec.dateClosed}}</td>
                </ng-container>
                <ng-container matColumnDef="createdBy">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Created By</th>
                  <td mat-cell *matCellDef="let spec">{{spec.createdBy}}</td>
                </ng-container>
                <ng-container matColumnDef="specialtyId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header disabled>Actions</th>
                  <td mat-cell *matCellDef="let spec">
                    <button mat-icon-button *ngIf="!labService.readonly" matTooltip="Edit" (click)="editLabSpecialty(spec)"
                      [matTooltipShowDelay]="750">
                      <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">edit</mat-icon>
                    </button>
                    <button mat-icon-button *ngIf="!labService.readonly" matTooltip="Delete" (click)="deleteLabSpecialty(spec.specialtyId)"
                      [matTooltipShowDelay]="750">
                      <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''" class="text-red-500">delete
                      </mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
          <!-- <mat-paginator [pageSizeOptions]="getPageSizeOptions()" #TablePaginator="matPaginator" showFirstLastButtons>
          </mat-paginator> -->
        </div>

      </mat-card-content>

    </mat-card>
  </div>

  <form [formGroup]="specialtyFormGroup">
    <div class="flex flex-col" *ngIf="editMode == 'edit'">
      <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                'bg-gray-600': sharedService.userTheme === 'dark',
                'bg-indigo-50': sharedService.userTheme === 'light'}">
        <div class="flex flex-col">

          <div class="flex flex-row gap-4">
            <div class="flex flex-row flex-wrap w-full sm:flex-col">
              <mat-card-content class="w-1/2">
                <div class="flex flex-col mt-4 w-full">

                  <mat-form-field>
                    <mat-label>Specialty</mat-label>
                    <input matInput formControlName="MajorCat">
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>TCD</mat-label>
                    <input matInput formControlName="T_cd">
                    <mat-error *ngIf="specialtyFormGroup.get('T_cd').invalid">
                      Required field.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Sub Specialty</mat-label>
                    <input matInput formControlName="Code">
                    <mat-error *ngIf="specialtyFormGroup.get('Code').invalid">
                      Required field
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>PT</mat-label>
                    <mat-select formControlName="Pt">
                      <mat-option value=""></mat-option>
                      <mat-option value="Y">Y</mat-option>
                      <mat-option value="N">N</mat-option>
                    </mat-select>
                    <mat-error *ngIf="specialtyFormGroup.get('Pt').invalid">
                      Required field.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Opened</mat-label>
                    <input matInput [matDatepicker]="DateOpened" formControlName="DateOpened">
                    <mat-datepicker-toggle matSuffix [for]="DateOpened"></mat-datepicker-toggle>
                    <mat-datepicker #DateOpened></mat-datepicker>
                    <mat-error *ngIf="specialtyFormGroup.get('DateOpened').invalid">
                      Invalid Date.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Closed</mat-label>
                    <input matInput [matDatepicker]="DateClosed" formControlName="DateClosed">
                    <mat-datepicker-toggle matSuffix [for]="DateClosed"></mat-datepicker-toggle>
                    <mat-datepicker #DateClosed></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Volume</mat-label>
                    <input matInput formControlName="Volume">
                    <mat-error *ngIf="specialtyFormGroup.get('Volume').invalid">
                      Required field
                    </mat-error>
                  </mat-form-field>

                </div>
              </mat-card-content>
            </div>
          </div>


        </div>
      </mat-card>

    </div>

    <div class="flex flex-col" *ngIf="editMode == 'add'">
      <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                'bg-gray-600': sharedService.userTheme === 'dark',
                'bg-indigo-50': sharedService.userTheme === 'light'}">
        <div class="flex flex-col">

          <div class="flex flex-row gap-4">
            <div class="flex flex-row flex-wrap w-full sm:flex-col">
              <mat-card-content class="w-1/2">
                <div class="flex flex-col mt-4 w-full">

                  <mat-form-field>
                    <mat-label>Sub Specialty</mat-label>
                    <mat-select formControlName="Code" (selectionChange)="updateFields($event.value)">
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let item of specialties" [value]="item.licAbbrev">{{item.licAbbrev}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="specialtyFormGroup.get('Code').invalid">
                      Required field.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Specialty</mat-label>
                    <input matInput formControlName="MajorCat">
                    <mat-error *ngIf="specialtyFormGroup.get('MajorCat').invalid">
                      Required field
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>TCD</mat-label>
                    <input matInput formControlName="T_cd">
                    <mat-error *ngIf="specialtyFormGroup.get('T_cd').invalid">
                      Required field
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>PT</mat-label>
                    <mat-select formControlName="Pt">
                      <mat-option value=""></mat-option>
                      <mat-option value="Y">Y</mat-option>
                      <mat-option value="N">N</mat-option>
                    </mat-select>
                    <mat-error *ngIf="specialtyFormGroup.get('Pt').invalid">
                      Required field.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Date Opened</mat-label>
                    <input matInput [matDatepicker]="DateOpened" formControlName="DateOpened">
                    <mat-datepicker-toggle matSuffix [for]="DateOpened"></mat-datepicker-toggle>
                    <mat-datepicker #DateOpened></mat-datepicker>
                    <mat-error *ngIf="specialtyFormGroup.get('DateOpened').invalid">
                      Invalid Date / Required.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Volume</mat-label>
                    <input matInput formControlName="Volume">
                    <mat-error *ngIf="specialtyFormGroup.get('Volume').invalid">
                      Required field
                    </mat-error>
                  </mat-form-field>

                </div>
              </mat-card-content>
            </div>
          </div>


        </div>
      </mat-card>

    </div>
  </form>

</div>
